const page = `
{settings}
document.title: Sametingsvalet 2017 – Álbmut
og.title: Sametingsvalet 2017 – Álbmut
og.image: http://quickshot.imgix.net/sametingsvalet2017/sami_albmut.jpg?w=1000
og.twitterImage: http://quickshot.imgix.net/sametingsvalet2017/sami_albmut.jpg?h=120&w=120&fit=crop
og.description: Den 21 maj är det Sametingsval. Vilka är de tre viktigaste frågorna att driva för respektive parti? Och vad är partiledarens egen hjärtefråga? Få svaren hos SVT Nyheters valspecial.
og.url: http://pejl.svt.se/sametingsvalet2017/sami-albmut-samiska-folket/
siteCatalyst.name: sametingsvalet2017-sami-albmut-samiska-folket
siteCatalyst.category: lyxartikel
{}
[+page]

luft:-48

{.bild}
  fil:sametingsvalet2017/sami_albmut.jpg
  storlek: lwide
{}

rubrik: Álbmut 
luft:-50
Almetjh, Almasj, Folket

{.div}
style.fontSize:1.2rem
[.+content]
  [Partiledare:] Lars-Paul Kroik
  luft:-40
  [Yrke:] Pensionär
  luft:-40
  [Ålder:] 74 år
  luft:-40
  [Bor i:] Borensberg, Östergötland
  luft:-40
  [Min hjärtefråga:] Samers lika rätt och möjligheter.
[]
{}


mellanrubrik: Varför ska man rösta på er?

Vi arbetar för att samisk rätt ska knytas till folket samerna och att lagstiftningen ändras och anpassas till den status samerna har inskrivit i Regeringsformen.


mellanrubrik: Vilka tre frågor är viktigast för ert parti?
[.lista-sameting]
  * Staten ska vidta lämpliga åtgärder så att alla samer, inklusive samer utan medlemskap i sameby, har lika tillgång till land och vatten och att i detta syfte införa nödvändiga lagändringar för att onödiga skillnader mellan samer tas bort. 
  * Sametinget tilldelas uppgifter och ansvar inom alla områden som berör samer, tex. markfrågor, ansvar för repatriering av samiska kvarlevor, administrering av jakt och fiske etc.
  * Effektiv konsultationsordning med staten baserad på jämbördig dialog samt bilaterala samtal och förhandlingar.
[]


mellanrubrik: Kontakt
text: Hemsida: [ www.albmut.se | http://www.albmut.se/ ]
luft:-50
text: Facebook: [ facebook.com/profile.php?id=100015537398521 | https://www.facebook.com/profile.php?id=100015537398521 ]
luft:-50
text: E-post: [ lars-paul@albmut.se | mailto:lars-paul@albmut.se ]

linje:4px

luft:-30

rubrik4: Läs om de andra partierna:

[Min Geaidnu | /sametingsvalet2017/min-geaidnu/ | button]
[Samerna | /sametingsvalet2017/samerna/ | button]
[Álbmut  | /sametingsvalet2017/sami-albmut-samiska-folket/ | button]
[Landspartiet Svenska Samer | /sametingsvalet2017/landspartiet-svenska-samer/ | button]
[Samelandspartiet | /sametingsvalet2017/samelandspartiet/ | button]
[Guovssonásti  | /sametingsvalet2017/guovssonasti/ | button]
[Jakt- och fiskesamerna | /sametingsvalet2017/jakt-och-fiskesamerna/  | button]
[Vuovdega - Skogssamerna | /sametingsvalet2017/vuovdega-skogssamerna/ | button]
[Samiska folkomröstningspartiet | /sametingsvalet2017/samiska-folkomrostningspartiet/ | button]
[Jämför dina åsikter med partierna | /sametingsvalet2017/vad-tycker-partierna/ | button_black]


{.sharebuttons}
  title: Sametingsvalet 2017 – Álbmut
  url: http://pejl.svt.se/sametingsvalet2017/sami-albmut-samiska-folket/
{}


[]
`;

export default page;





/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/data/articles/sametingsvalet2017-sami-albmut-samiska-folket.js
 **/